{
  "es": {
    "reminder": {
      "actions": {
        "cancel": "Cancelar",
        "edit": "Editar",
        "hideReminders": "Ocultar recordatorios",
        "save": "Guardar",
        "showReminders": "Mostrar recordatorios"
      },
      "contactType": {
        "customer": "Cliente",
        "partner": "Colaborador"
      },
      "labels": {
        "after": "después",
        "before": "antes",
        "click": "Haz clic aquí para configurar el recordatorio",
        "date": "el {date}",
        "dateAfterDueDate": "Después de la fecha límite",
        "dateAlreadyPassed": "la fecha ya ha pasado",
        "decisionApprovedNotSent": "Se ha tomado la decisión. Los recordatorios que aún estaban en cola se han cancelado.",
        "dueDate": "la fecha límite",
        "editTitle": "Editar recordatorios",
        "here": "aquí",
        "infoReminders": "Los recordatorios solo están activos para las cuotas con una fecha límite configurada.",
        "noReminderSet": "Sin recordatorio configurado",
        "reminder": "Recordatorio",
        "reminders": "Recordatorios",
        "remindersCustomer": "Recordatorios para tu cliente",
        "remindersPartners": "Recordatorios para los colaboradores",
        "reminders_count": "{count} recordatorio configurado | {count} recordatorios configurados",
        "sendOnDeadline": "El recordatorio se enviará en la fecha límite",
        "sendReminder": "Enviar recordatorio",
        "sent_at": "Recordatorio enviado el {date}",
        "warningReminders": "Esta acción sustituye los 4 recordatorios. Cualquier recordatorio que se deje en blanco aquí se eliminará para todas las decisiones."
      },
      "toasts": {
        "update": "Recordatorio actualizado correctamente"
      }
    }
  }
}
